module.exports = __webpack_public_path__ + "img/logo.5626a61e.svg";